import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAutoSize: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconAutoSize"><Path fillRule="evenodd" clipRule="evenodd" d="M6.75 2C5.23122 2 4 3.23122 4 4.75V19.25C4 20.7688 5.23122 22 6.75 22H17.25C18.7688 22 20 20.7688 20 19.25V4.75C20 3.23122 18.7688 2 17.25 2H6.75ZM5.5 4.75C5.5 4.05964 6.05964 3.5 6.75 3.5H17.25C17.9404 3.5 18.5 4.05964 18.5 4.75V19.25C18.5 19.9404 17.9404 20.5 17.25 20.5H13V13.75C13 12.2312 11.7688 11 10.25 11H5.5V4.75Z" fill="currentColor"/></CentralIconBase>;
});

export default IconAutoSize;
